import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';


//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit {

  pageName = "Search Results for: ";
  searchTerm = "";

  products: any;
  p: number = 1;
  itemsPerPage = 20;
  displayedProducts = []
  numberOfValidProducts = 0
  loading = true

  constructor(
    private router: Router,
    private _data: CommonDataService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {

      if(params['term']) {

        if(this.searchTerm != params['term']) {
          this.searchTerm = params['term'];

          this.displayedProducts = []
          this.numberOfValidProducts = 0

          this.getProducts()
        }
        
      } 
    });

    // this.getProducts()
   }

  ngOnInit() {
  }

  getValidProducts() {
    // this.products.sort((a,b)=>a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name'].localeCompare(b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['name']))
    // return this.products.sort((a,b)=>b['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'] - a['cover']['model']['modelData']['formFieldsEntities']['productDetails']['regular_price'])

    return this.products.filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['ProductFlags']['published'] === false);
  }

  getProducts() {
    let queryData = new FormData();
    queryData.append('modelName', 'Product');
    queryData.append('productDetails->name', this.searchTerm);
    queryData.append('searchTableQueary',  'true');
    queryData.append('operator', 'LIKE');

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.products = data['covers'];
          
          if(data['covers'].length > 0) {
            this.displayedProducts = this.getValidProducts()

            this.numberOfValidProducts = this.displayedProducts.length
            
          }

          this.loading = false

        },
        error => {

          console.log(error);
          iziToast.success({
            title: 'Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Failed to get products.'
        });

        $('#loader').hide();

        this.loading = false

        },

        () => {
            $('#loader').hide();
            this.loading = false
        }
      );
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

}
